import {IHeaderCompParams} from "./ag-grid";

interface State {
    isSelected: boolean;
    totalItemsCount: number;
    loadedItemsCount: number;
    selectedItemsCount: number;
}

declare const $: any;

export default class AgSelectAllHeader {
    private eGui: HTMLElement = document.createElement('div',);
    private agParams: IHeaderCompParams | undefined;
    private eSelectAllCheckbox: Element | null | undefined;

    private onSortChangedListener: any;
    private onSortOffRequestedListener: any;
    private onSortAscRequestedListener: any;
    private onSortDescRequestedListener: any;

    private eSortOff: Element | null | undefined;
    private eSortAsc: Element | null | undefined;
    private eSortDesc: Element | null | undefined;

    private state: State = {
        isSelected: false,
        totalItemsCount: 0,
        loadedItemsCount: 0,
        selectedItemsCount: 0
    };

    init(params: IHeaderCompParams): void {
        this.agParams = params;
        this.eGui.className = 'ag-cell-label-container';
        this.eGui.style.height = '30px';
        this.eGui.innerHTML =
            `<div class="ag-header-cell-label" role="presentation" id="cbName"><span style="overflow: unset !important;" class="ag-header-cell-text" role="columnheader">${this.agParams.displayName}</span>
                <div class="ag-header-cell-sorted" role="presentation" id="cbSort"><span id="eSortAsc" class="ag-header-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"><span class="ag-icon ag-icon-asc" unselectable="on"></span></span><span id="eSortDesc" class="ag-header-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"><span class="ag-icon ag-icon-desc" unselectable="on"></span></span><span id="eSortOff" style="width: 100%; height: 100%" class="ag-header-icon ag-sort-descending-icon" aria-hidden="true"><span unselectable="on"></span></span></div>
             </div>
             ${params.column.colDef.headerTooltip ? '<i style="color: orange; margin-right: 2px" class="fas fa-question-circle fa-lg ag-help-question-mark"></i>' : ""}
             <div class="ag-header-select-all" role="presentation" id="cbSelectAll"><span class="ag-checkbox-checked ag-hidden" role="presentation"><span class="ag-icon ag-icon-checkbox-checked" unselectable="on"></span></span> <span class="ag-checkbox-unchecked" role="presentation"><span class="ag-icon ag-icon-checkbox-unchecked" unselectable="off"></span></span>  <span class="ag-checkbox-indeterminate ag-hidden" role="presentation"><span class="ag-icon ag-icon-checkbox-indeterminate" unselectable="on"></span></span>  <span class="ag-checkbox-label" role="presentation"></span></div>`;

        this.eSortOff = this.eGui.querySelector("#eSortOff");
        this.eSortAsc = this.eGui.querySelector("#eSortAsc");
        this.eSortDesc = this.eGui.querySelector("#eSortDesc");
        this.eSelectAllCheckbox = this.eGui.querySelector("#cbSelectAll");

        (this.eSelectAllCheckbox as Element).addEventListener('click', () => {
            if (!this.state.isSelected) {
                this.selectAll();
            } else {
                this.deselectAll();
            }
        });

        if (this.agParams.enableSorting) {
            this.onSortAscRequestedListener = this.onSortRequested.bind(this, 'desc');
            (this.eSortAsc as Element).addEventListener('click', this.onSortAscRequestedListener);
            this.onSortDescRequestedListener = this.onSortRequested.bind(this, 'off');
            (this.eSortDesc as Element).addEventListener('click', this.onSortDescRequestedListener);
            this.onSortOffRequestedListener = this.onSortRequested.bind(this, 'asc');
            (this.eSortOff as Element).addEventListener('click', this.onSortOffRequestedListener);

            this.onSortChangedListener = this.onSortChanged.bind(this);
            this.agParams.column.addEventListener('sortChanged', this.onSortChangedListener);
            this.onSortChanged();
        } else {

        }
        params.api.gridCore.gridOptions.selectAllHeader = this;
    };

    getGui(): HTMLElement | undefined {
        return this.eGui;
    };

    destroy() {
        (this.agParams as IHeaderCompParams).column.removeEventListener('sortChanged', this.onSortChangedListener);
    };

    getState(): State {
        return this.state;
    }

    isSelected(): boolean {
        return this.state.isSelected;
    }

    selectAll(): void {
        (this.agParams as IHeaderCompParams).api.forEachNode(function (node: any) {
            node.setSelected(true);
        });
        this.state.isSelected = true;
        this.updateCheckboxIcon();
    }

    deselectAll(): void {
        (this.agParams as IHeaderCompParams).api.deselectAll();
        this.state.isSelected = false;
        this.updateCheckboxIcon();
    }

    update(totalItemsCount: number, loadedItemsCount: number, selectedItemsCount: number): void {
        this.state.totalItemsCount = totalItemsCount;
        this.state.loadedItemsCount = loadedItemsCount;
        this.state.selectedItemsCount = selectedItemsCount;
    }

    resetState() {
        this.state.isSelected = false;
        this.state.totalItemsCount = 0;
        this.state.loadedItemsCount = 0;
        this.state.selectedItemsCount = 0;
    }


    onRowSelected = (params: any) => {
        if (params.api.getSelectedRows().length < this.state.selectedItemsCount) {
            this.state.isSelected = false;
        }
        this.updateCheckboxIcon();
    };

    onSortChanged = () => {
        function deactivate(toDeactivateItems: any) {
            toDeactivateItems.forEach(function (toDeactivate: Element) {
                toDeactivate.classList.add('ag-hidden');
            });
        }

        function activate(toActivate: any) {
            toActivate.classList.remove('ag-hidden');
        }

        if ((this.agParams as IHeaderCompParams).column.isSortAscending()) {
            deactivate([this.eSortDesc, this.eSortOff]);
            activate(this.eSortAsc);
        } else if ((this.agParams as IHeaderCompParams).column.isSortDescending()) {
            deactivate([this.eSortAsc]);
            activate(this.eSortDesc);
        } else {
            deactivate([this.eSortAsc, this.eSortDesc]);
            activate(this.eSortOff);
        }
    };

    onSortRequested = (order: any, event: any) => {
        (this.agParams as IHeaderCompParams).setSort(order, event.shiftKey);
    };

    updateCheckboxIcon = () => {
        this.state.selectedItemsCount = (this.agParams as IHeaderCompParams).api.getSelectedRows().length;

        if (this.state.selectedItemsCount === 0) {
            $(this.eGui).children('#cbSelectAll').children('.ag-checkbox-unchecked').removeClass('ag-hidden');
            $(this.eGui).children('#cbSelectAll').children('.ag-checkbox-checked').addClass('ag-hidden');
            $(this.eGui).children('#cbSelectAll').children('.ag-checkbox-indeterminate').addClass('ag-hidden');
            this.state.isSelected = false;
        } else if (this.state.isSelected || this.state.selectedItemsCount === this.state.totalItemsCount) {
            $(this.eGui).children('#cbSelectAll').children('.ag-checkbox-checked').removeClass('ag-hidden');
            $(this.eGui).children('#cbSelectAll').children('.ag-checkbox-unchecked').addClass('ag-hidden');
            $(this.eGui).children('#cbSelectAll').children('.ag-checkbox-indeterminate').addClass('ag-hidden');
            this.state.isSelected = true;
        } else if (this.state.selectedItemsCount !== this.state.totalItemsCount) {
            $(this.eGui).children('#cbSelectAll').children('.ag-checkbox-indeterminate').removeClass('ag-hidden');
            $(this.eGui).children('#cbSelectAll').children('.ag-checkbox-checked').addClass('ag-hidden');
            $(this.eGui).children('#cbSelectAll').children('.ag-checkbox-unchecked').addClass('ag-hidden');
            this.state.isSelected = false;
        }
    };
}


// WEBPACK FOOTER //
// ./app/components/bo-core/common/AgSelectAllHeader.ts